import React from "react";
import { ConfirmationModal } from "../../components";
import { useDeleteQueryMutation } from "../../store";

const DeleteQuery = ({ show, onHide, id }) => {
  console.log(id);
  const [deleteQuery, { isLoading, isError, isSuccess, error }] =
    useDeleteQueryMutation();
  const deleteHandler = (e) => {
    e.preventDefault();
    deleteQuery(id);
  };
  return (
    <ConfirmationModal
      show={show}
      onHide={onHide}
      title="Delete Query"
      body="Do you really want to delete this Query ?"
      successMessage="Query Deleted Successfully!"
      submitHandler={deleteHandler}
      reducerProps={{
        loading: isLoading,
        success: isSuccess,
        error,
      }}
    ></ConfirmationModal>
  );
};

export default DeleteQuery;
